define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/TitleProperty"
],
    function (lang, TypeConstants, TypeProperty, TagProperty, TitleProperty) {
        var hash = {};

        hash[TypeConstants.SECTION] = lang.mixin({
            collapsePriority: {
                type: "number",
                notInAction: true,
                defaultValue: 0
            },
            icon: {
                type: "string",
                notInAction: true,
                defaultValue: "section_24",
                required: false
            }
        }, TypeProperty, TagProperty, TitleProperty);
        return hash;
    });

